import EnterpriseWelcomePage from './EnterpriseWelcomePage';
export default EnterpriseWelcomePage;
